var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 text-center"},[_c('b-img',{staticClass:"main-logo",attrs:{"src":"/img/logo.png","alt":"Cluji"}}),_c('h1',{staticClass:"mb-5 mt-3"},[_vm._v("Connexion")]),_c('login',{attrs:{"default-redirect":{name: 'mobile_app_home'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }